import { celebrityStories } from '@/mocks/celebrity';
import type { StoryCard } from '@/pages/home/types';

const stories: StoryCard[] = celebrityStories;

export default function Celebrity() {
  return (
    <section id="celebrity" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-100 border-y border-background-200">
      <div className="mb-8 md:mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold text-accent-800 bg-accent-100 px-3 py-1.5 rounded-full mb-4">
            <i className="ri-heart-3-line"></i> 明星绯闻
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
            恋情、行程与同框传闻的集中更新
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            娱乐话题往往先有讨论、后有回应。我们如实区分“已回应”与“待核实”，把每个话题的关键信息讲清楚。
          </p>
        </div>
        <span className="inline-flex items-center gap-2 text-sm text-foreground-600 whitespace-nowrap">
          <i className="ri-refresh-line text-primary-500"></i> 今日已更新 6 条
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {stories.map((story) => (
          <article
            key={story.id}
            className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-colors"
          >
            <div className="relative w-full h-52 overflow-hidden">
              <img
                src={story.image}
                alt={story.title}
                title={`${story.title} · 爆料网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 inline-flex items-center px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-bold">
                {story.category}
              </span>
            </div>
            <div className="p-4 md:p-5 flex-1 flex flex-col">
              <span className="text-xs text-foreground-500 mb-2">
                <i className="ri-time-line mr-1"></i>
                {story.time}
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-accent-800 transition-colors">
                {story.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{story.summary}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {story.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}